<template>
    <div class="cart-confirm">
        <button
            class="cart-confirm__button"
            @click="sendOrder"
        >
            Подтвердить заказ
        </button>
      <div class="cart-confirm__policy">
        <div class="cart-confirm__policy-wrap">
          <input
              type="checkbox"
              :id="uniqueId"
              required
              value="152"
              v-model="agreed"
          >
          <label class="cart-confirm__policy-text-wrap "
                 :for="uniqueId"
          >
            <span class="cart-confirm__policy-text">
                Согласен на&nbsp;<a :href="'uploads/ek/' + personalFilePath" target="_blank" class="cart-confirm__policy-link">
                    обработку персональных данных
                </a> и принимаю <a :href="'uploads/ek/' + policyFilePath" target="_blank" class="cart-confirm__policy-link">
                    политику конфиденциальности
                </a>
            </span>
          </label>
        </div>
      </div>
<!--        <div class="cart-confirm__policy">-->
<!--            Подтверждая заказ вы соглашаетесь с&nbsp;<a :href="'uploads/ek/' + policyFilePath"-->
<!--                                                   class="cart-confirm__policy-link" target="_blank">-->
<!--          политикой конфиденциальности</a>-->
<!--        </div>-->
    </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "TheCartConfirm",
    methods: {
      ...mapActions('order', {
        'send': 'send'
      }),
      ...mapActions('policyFilePathModule', {
        'fetchPolicyFile': 'fetch'
      }),
      ...mapActions('personalFilePathModule', {
        'fetchPersonalFile': 'fetch'
      }),
      async sendOrder() {
        if (!this.agreed) {
          alert('Для оформления заказа нужно согласиться с обработкой персональных данных');
          return;
        }
        const success = await this.send();
        if (success) {
          window.goalManager.proceedYandexGoal('submit_shopping_cart_success');
          window.goalManager.proceedYandexGoal('success_order_allForm');
          window.goalManager.proceedVkGoal('success_order_allForm');
        }
      }
    },
    computed: {
      policyFilePath: {
        get () {
          return this.$store.state.policyFilePathModule.policyFilePath
        },
        set (value) {
          this.$store.commit('order/SetPolicyFilePath', value)
        }
      },
      personalFilePath: {
        get () {
          return this.$store.state.personalFilePathModule.personalFilePath
        },
        set (value) {
          this.$store.commit('order/SetPersonalFilePath', value)
        }
      }
    },
    data() {
      return {
        uniqueId: '',
        agreed: false
      }
    },
    created() {
      this.uniqueId = 'checkbox-' + Math.random().toString(36).substr(2, 9);
    },
    mounted() {
      this.fetchPolicyFile();
      this.fetchPersonalFile();
    }
  }

</script>

<style lang="scss">

</style>